<template>
  <!-- The Modal -->
  <div
      id="createModal"
      class="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
              type="button"
              class="close"
              data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
              title="Create News"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <label for="title_en">Title «<span class="text-muted">English</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Title En"
                          rules="required"
                      >
                        <b-form-input
                            id="name_en"
                            v-model="createdNews.title"
                            name="name_en"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label for="title_ar">Title «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Title Ar"
                          rules="required"
                      >
                        <b-form-input
                            id="title_ar"
                            v-model="createdNews.titleAR"
                            class="arabic-font"
                            name="title_ar"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                            :dir="'rtl'"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="contentEn">Content «<span class="text-muted">English</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Content En"
                          rules="required"
                      >
                        <template>
                          <b-form-textarea
                              id="contentEn"
                              v-model="createdNews.content"
                              :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                              placeholder=""
                              rows="5"
                              cols="12"
                          />
                        </template>

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="contentAr">Content «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                          id="contenAr"
                          #default="{ errors }"
                          name="Content Ar"
                          rules="required"
                          :dir="'rtl'"
                      >
                        <template>
                          <b-form-textarea
                              id="contentAr"
                              v-model="createdNews.contentAR"
                              class="arabic-font"
                              :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                              placeholder=""
                              rows="5"
                              cols="12"
                          />
                        </template>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="datepicker-full-width">Date</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Date"
                          rules="required"
                      >
                        <template>
                          <b-form-datepicker
                              id="datepicker-full-width"
                              v-model="createdNews.date"
                              :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                              menu-class="w-100"
                              calendar-width="100%"
                          />
                        </template>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="cover">Cover</label>
                      <validation-provider
                          id="cover"
                          #default="{ errors }"
                          name="cover"
                          rules=""
                      >
                        <vue-dropzone
                            id="image"
                            ref="updateNewsRef"
                            name="image"
                            :options="dropzoneOptions"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                </b-row>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

            <template #code>
              {{ codeMultiple }}
            </template>
          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea, BFormDatepicker,
} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import vue2Dropzone from 'vue2-dropzone'
import {codeMultiple, codeBasic} from './code'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import newsService from '@/services/newsService'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormDatepicker,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      emailValue: '',
      title_ar: '',
      title_en: '',
      content_ar: '',
      content_en: '',
      PasswordValue: '',
      passwordCon: '',
      required,
      password,
      email,
      confirmed,
      codeMultiple,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        addRemoveLinks: true,
        acceptedFiles: ".jpeg,.jpg,.png,.gif",
        dictRemoveFile: 'Remove',
      },
      createdNews: {
        title: '',
        titleAR: '',
        content: '',
        contentAR: '',
        cover: '',
        date: '',
      },
      codeBasic,
      selected: {title: 'Square'},
      option: [{title: 'Square'}, {title: 'Rectangle'}, {title: 'Rombo'}, {title: 'Romboid'}],
    }
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.createdNews.cover = this.$refs.updateNewsRef.getAcceptedFiles()[0]
          // eslint-disable-next-line
          newsService.post(this.createdNews)
              .then(response => {
                if (response && response.status === 200) {
                  this.$emit('refresh', 'true')

                  /* Reset Inputs */
                  this.createdNews = {
                    title: '',
                    titleAR: '',
                    content: '',
                    contentAR: '',
                    cover: '',
                    date: '',
                  }
                  /* Reset Dropzone Area */
                  this.$refs.updateNewsRef.removeAllFiles()
                  /* Close Modal */
                  $('#createModal').modal('hide')

                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'Success',
                      icon: 'CheckIcon',
                      variant: 'success',
                      text: 'News Is Created Successfully !',
                    },
                  })
                }
                /* Hide Spinner */
                this.loading = false
              })
              .catch(
                  function (error) {
                    $('#createModal').modal('hide')
                    this.$toast({
                      component: ToastificationContent,
                      position: 'top-right',
                      props: {
                        title: 'Success',
                        icon: 'CheckIcon',
                        variant: 'Error',
                        text: 'Error !',
                      },
                    })
                    return Promise.reject(error)
                  },
              )
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

label {
  font-weight: bold;
}
</style>
